export const field =
  "w-full border-2 border-ink bg-white px-4 py-3 font-body text-sm focus:outline-none focus:ring-2 focus:ring-staxmagenta";

export const cfield =
  "w-full border-2 border-ink bg-white px-3 py-2 font-body text-sm focus:outline-none focus:ring-2 focus:ring-staxmagenta";

export const btn =
  "inline-flex items-center justify-center gap-2 border-2 border-ink px-4 py-2.5 font-display uppercase text-sm transition-transform hover:-translate-y-0.5 disabled:opacity-50";

export const fmtTs = (ts) => {
  if (!ts) return "";
  const d = new Date(ts);
  if (isNaN(d)) return ts;
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const fmtTime = (ts) => {
  if (!ts) return "";
  const d = new Date(ts);
  if (isNaN(d)) return ts;
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
};

export const Card = ({ title, color = "bg-staxyellow", testid, action, children }) => (
  <section data-testid={testid} className="border-4 border-white/90 bg-paper text-ink shadow-hard-yellow">
    <div className={`border-b-4 border-ink ${color} px-6 py-4 flex flex-wrap items-center justify-between gap-3`}>
      <h2 className="font-display uppercase text-2xl">{title}</h2>
      {action}
    </div>
    <div className="p-6">{children}</div>
  </section>
);
